<template>
  <div class="v-view chart-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>
    <div class="Organization-content ">
      <!-- <vue-seamless-scroll :class-option="defaultOption" :data="swiperData" class="sv-swiper"> -->
      <div class="sv-swiper scroller">
        <div v-for="(value, key) in swiperData" class="seamless-item" :key="key" @click="toPop(value)">
          <img v-if="value.CompanyPhotos && value.CompanyPhotos.length > 0" :src="value.CompanyPhotos[0]" alt="">
          <img v-else src="../assets/images/yongning/default.png" alt="">
          <p></p>
          <div class="seamless-item-content">
            <p>{{ value.CompanyName }}</p>
            <p>地址：{{ value.CompanyAddress }}</p>
            <p>联系人：{{ value.ComHandlePerson }}</p>
            <p>联系电话：{{ value.ComHPerPhone }}</p>
          </div>
        </div>
      </div>

      <!-- </vue-seamless-scroll> -->
    </div>
    <!-- @opened="onDialogOpened" -->
    <el-dialog top="20vh" title="机构介绍" @closed="closed" custom-class="v-dialog v-Organization-dialog"
      :visible.sync="dialogVisible" append-to-body>
      <el-tabs v-model="editableTabsValue">
        <el-tab-pane label="机构信息" name="first">
          <div class="sv-wrapper">
            <div class="sv-order">
              <div class="sv-order-info">
                <div><label>机构名称：</label>{{ orderData.CompanyName || "--" }}</div>
                <div><label>成立时间：</label>{{ orderData.FoundingTime | getdate }}</div>
                <div><label>注册资金：</label>{{ orderData.RegisteredCapital || "--" }}</div>
                <div><label>法&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人：</label>{{ orderData.Corporate || "--" }}</div>
                <div><label>机构负责人：</label>{{ orderData.ComHandlePerson || "--" }}</div>
                <div><label>负责人电话：</label>{{ orderData.ComHPerPhone || "--" }}</div>
                <div><label>公司电话：</label>{{ orderData.Tel || "--" }}</div>
                <div><label>规模面积：</label>{{ orderData.ScaleArea || "--" }}</div>
                <div><label>机构等级：</label>{{ orderData.AAALevel || "--" }}</div>

                <div><label>员工总数：</label>{{ orderData.EmployeeCount || "--" }}</div>
                <div><label>管理人员总数：</label>{{ orderData.ManagerCount || "--" }}</div>
                <div><label>持证人数：</label>{{ orderData.HolderCount || "--" }}</div>
                <div><label>日助餐人次：</label>{{ orderData.DayMealCount || "--" }}</div>
                <div><label>服务老人总数：</label>{{ orderData.PersonCount || "--" }}</div>
                <div><label>服务内容：</label>{{ orderData.Remark || "--" }}</div>
                <div><label>机构地址：</label>{{ orderData.CompanyAddress || "--" }}</div>
              </div>
              <div class="pop-right">
                <swiper v-if="orderData.CompanyPhotos && orderData.CompanyPhotos.length > 0" ref="photoSwiper"
                  class="sv-order-swiper" :options="orderOption">
                  <swiper-slide v-for="(item, index) in orderData.CompanyPhotos" :key="index">
                    <img :src="item" alt="#" />
                  </swiper-slide>
                </swiper>
                <img class="monitors" v-if="orderData.Monitors && orderData.Monitors.length > 0"
                  @click="toMonitioner(orderData)" src="../assets/images/icon_video.png" alt="">
                <!-- <img class="monitors" v-if="orderData.WebSite && orderData.WebSite!=''"
                  @click="toWebSite(orderData.WebSite)" src="../assets/images/vr.png" alt=""> -->
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="机构风采" name="second">
          <!-- <div v-for="(value,key) in newList"><label>机构新闻：</label>{{ orderData.CompanyName || "--" }}</div> -->
          <!-- <a class="link" v-for="(value, key) in newList" :key="key" :href="value.LinkUrl" target="_blank">{{ value.Name
            }}</a> -->
          <div v-if="newList && newList.length > 0" class="newList scroller">
            <a class="link" v-for="(value, key) in newList" :key="key" :href="value.LinkUrl" target="_blank">
              <div class="cell">
                <img v-if="value.ImagePaths && value.ImagePaths.length > 0" :src="value.ImagePaths[0]" alt="">
                <img v-else src="../assets/images/news.png" alt="">
                <div>
                  <p>
                    {{ value.TitileName }}
                  </p>
                  <p>{{ value.CreateTime | getTime }}</p>
                </div>
              </div>
            </a>

          </div>
          <div v-else class="newList center-fiex">
            <img src="../assets/images/Nodata.png" alt="">
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: 'OrganizationInformationDisplay',
  computed: {
    ...mapGetters(['cid']),
    defaultOption() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        isSingleRemUnit: true,
      }
    }
  },
  components: {
    vueSeamlessScroll
  },
  props: {
    type: {
      type: String,
      default: 'pie',
    },
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '机构组织信息展示',
    },
  },
  filters: {
    getTime(data) {
      if (data) {
        return data.split("T")[0] + " " + data.split("T")[1].split('.')[0]
      } else {
        return "--"
      }
    },
    getdate(data) {
      if (data) {
        return data.split("T")[0]
      } else {
        return "--"
      }
    }
  },
  watch: {
    dialogVisible(ndata) {
      if (!ndata) {
        this.orderData = {}
      }
    }
  },
  data() {
    let that = this;
    return {
      editableTabsValue: 'first',
      videodialogVisible: false,
      swiperData: [],
      dialogVisible: false,
      orderData: {},
      orderOption: {
        grabCursor: true,
        speed: 1000,
        loop: true,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        on: {
          // click(e) {
          //   const index = +this.clickedSlide.dataset.index
          //   const order = vm.swiperList[index]
          //   that.toPop(order)
          // },
        }
      },
      newList: []
    }
  },
  created() {
    this.getServiceCompanyDetail(this.cid)
  },
  beforeDestroy() { },
  mounted() {
    PubSub.subscribe('organ', (msg, data) => {
      const cid = data.cid
      for (let index = 0; index < this.swiperData.length; index++) {
        const element = this.swiperData[index];
        if (element.SysCompanyId == cid) {
          console.log(element.CompanyName);
          this.orderData = element
          this.newList = element.News
          this.dialogVisible = true
        }
      }
    })
  },
  methods: {
    toWebSite(url){
      window.open(url)
    },
    closed() {
      this.editableTabsValue = 'first'
    },
    toMonitioner(orderData) {
      this.videodialogVisible = true;
      this.list = orderData.Monitors
      PubSub.publish('video', {
        visible: true,
        name: orderData.CompanyName,
        list: this.list
      })
    },
    toPop(params) {
      this.orderData = params
      // console.log(ImagePaths);
      // params.News.ImagePaths = ImagePaths
      this.newList = params.News
      this.dialogVisible = true
    },
    getServiceCompanyDetail(cid) {
      let that = this;
      this.$api
        .getServiceCompanyDetail(cid)
        .then((data) => {
          // console.log(data)
          if (!data || !data.length) return
          data = data.map(item => {
            let photo = item.CompanyPhotos
            photo = photo.map(item2 => {
              return process.env.VUE_APP_BASE_URL + item2
            })
            item.CompanyPhotos = photo
            return item
          })
          data = data.map(items => {
            items.News = items.News.map(item => {
              // return process.env.VUE_APP_BASE_URL + item
              item.ImagePaths = item.ImagePaths.map(item => {
                return process.env.VUE_APP_BASE_URL + item
              })
              return item
            })
            return items
          })

          this.swiperData = data
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.center-fiex {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.cell:hover {
  div {
    color: #00a4f0;
  }
}

.cell {
  width: 100%;
  padding: 5px 0px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  cursor: pointer;

  div {
    width: calc(100% - 130px);
    margin-left: 20px;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    p:first-child {
      // display: block;
      width: 100%;

      font-size: 20px;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p:last-child {
      font-size: 16px;
      font-weight: normal;
    }
  }

  img {
    width: 100px;
    height: 100px;
  }
}

.newList {
  width: 100%;
  height: 480px;
  overflow-y: auto;
}

.padding50 {
  padding: 20px 0;
}

.link {
  color: #fff;
  font-size: 18px;
  // text-decoration: underline;
  margin-bottom: 10px;
}

.myPlayerMonitor {
  width: 760px;
  height: 369px;
}

.sv-order-swiper {
  height: 26.388vh;
}

.pop-right {
  position:absolute;
  top: 0px;
  right: 0px;
  height: 48.44vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .monitors {
    width: 128px;
    height: 128px;
    margin-top: 20px;
    cursor: pointer;
  }
}

.sv-order-info {
  width: calc(100%) !important;
}

.Organization-content {
  width: 100%;
  height: 100%;
  // background-color: red;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.sv-swiper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.seamless-item {
  cursor: pointer;
  width: 100%;
  height: 11.57vh;
  // background-color: red;
  // margin-bottom: 0.926vh;
  padding: 0px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -0.5px;
    width: 100%;
    height: 1px;
    background: url(../assets/images/bg_line.png) no-repeat center center/60% 100%;
  }

  img {
    width: 90px;
    height: 100px;
    margin-right: 10px;
    border-radius: 4px;
    object-fit: fill;
  }
}

.seamless-item-content {
  width: calc(100% - 100px);
  height: 10vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  p {
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 14px;
    color: #00a4f0;
  }

  p:first-child {
    font-size: 18px;
    color: #fff;
  }
}
</style>
